let deferredPrompt = null;

export const setDeferredPrompt = (event) => {
  deferredPrompt = event;
};

export const getDeferredPrompt = () => deferredPrompt;

export const clearDeferredPrompt = () => {
  deferredPrompt = null;
};

export const isInstallPromptAvailable = () => deferredPrompt !== null;